import React, { useEffect, useState } from 'react';
// import { Editor } from '../../components/Editor'
import { useForm } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { clearAll, onAddEvaluation, setErrorMessageNotapUser, setLoadingNotapUser, showCommentRichTextFormFunc, showPrevCertificateDetailsFunc } from '../../../../config/redux/slice/notapUserSlice';
import { getRequest } from '../../../../helpers/request';
// import {
//   clearAll
// } from '../../../config/redux/slice/appSlice';
import { postRequest } from '../../../../helpers/request';
import { appApi } from '../../../../utils/endpoints/appApi';
import { Spinner } from '../../../components';
import CertificateDetailsComponent from '../CertificateDetailsComponent';

export default function ViewCetrificateDetailsModal() {
  const dispatch = useDispatch()

    const {
      certificateManagement:{previousCertificateDetails},
    } = useSelector((state) => state.notapUser)

  
  const closeModal = ()=>{
      dispatch(showPrevCertificateDetailsFunc({modal:false}))
  }

  return (
    <div 
        className="modal fade show" 
        id="basicModal" 
        tabIndex="-1"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.3)",
          overflowY: 'auto'
        }}
     >

  <div style={{overflowY: 'auto'}} className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
        <div className="email-right-column app email-body p-2 p-sm-3 p-md-4 p-xl-5">
        <div className="modal-header px-4">
            <h5 className="modal-title font-weight-bold" id="exampleModalCenterTitle">Previous Certificate Details</h5>
            <button 
              type="button" 
              className="close" 
              data-dismiss="modal" 
              aria-label="Close"
              onClick={()=>{closeModal()}}
          >
            <span aria-hidden="true">×</span>
          </button>
          </div>
          <div className='modal-body'>
          <CertificateDetailsComponent certificateObject={previousCertificateDetails}/>
          </div>
        </div>
    </div>
  </div>
        </div>
  )
}
